import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '..';
import Button from '../Button';
import { Tag } from 'antd';
import { ApisEnumLabel } from 'Data/enums/Apis';
import { Modal } from './styles';
import { useFeatureFlag } from 'Hooks/useFeatureFlag';
import { useSelector } from 'react-redux';
import { getTheme } from 'Store/MultiDomain/MultiDomain.selector';

type ModalBloquedSADownloadProps = {
  platform: number;
  onCancel: () => void;
}

const ModalBloquedSADownload: FC<ModalBloquedSADownloadProps> = ({ 
  platform, 
  onCancel, 
}) => {
  const { t } = useTranslation(['sharedModals', 'common']);
  const blockedSABlogUrlFlag = useFeatureFlag('blocked-SA-blog-url');
  const blockedSABlogUrl = (blockedSABlogUrlFlag.enabled && typeof blockedSABlogUrlFlag.value === 'string') 
  ? blockedSABlogUrlFlag.value 
  : 'https://www.maletadoengenheiro.com.br/blog';

  const theme = useSelector(getTheme);

  return (
    <Modal>
      <div className="Wrapper">
        <div className="content">
          <div className="iconBox">
            <Tag color={theme.colors.danger.danger} className="tag">
              <Icon icon="aviso" color="branco" customSize={12} />
              {t('sharedModals:modalBloquedSADownload.connectionError')}
            </Tag>

            <Icon
              icon='cancelar'
              customSize={12}
              color='cinzaOpaco'
              onClick={onCancel}
            />
          </div>

          <h4 className="title">
            {t('sharedModals:modalBloquedSADownload.title', { platform: ApisEnumLabel[platform] })}
          </h4>
          <p className="description">
            {t('sharedModals:modalBloquedSADownload.description', { platform: ApisEnumLabel[platform] })}
          </p>
        </div>

        <div className="Footer">
          <div className="link">
            <a
              href={blockedSABlogUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('common:learnMore')}
            </a>
          </div>
          <Button
            type="primary"
            onClick={onCancel}
          >
            {t('common:close')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ModalBloquedSADownload;
